// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFrontSide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';

import ReportPartTypeManager from 'Izenda.ReportPartTypeManager';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import { REPORT_PART_TYPE as TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import commonDataStore from 'logic/Izenda.ReportDesignerCommonDataStore';
import { omit, flow, get, find, isNil, includes } from 'lodash/fp';

@observer
class ReportPartFrontSide extends Component {
  static propTypes = {
    reportPart: React.PropTypes.object
  };

  render() {
    const props = this.props;
    const { autoSize } = props;
    const restProps = omit(['autoSize'], props);
    const FrontSideView = ReportPartTypeManager.getReportFrontSide(props.reportPart.type);
    const error = flow(
      find(function(message) {
        return message.reportPartId === props.reportPart.id;
      }),
      get('message')
    )(props.store.reportPartErrorMessages);

    return (
      <div className="report-part-front-side">
        {!isNil(error) ? (
          <div className="front-side-content">{error}</div>
        ) : autoSize ? (
          <div className="front-side-content">
            <FrontSideView {...restProps} />
          </div>
        ) : (
          <ScrollBox>
            <div className="front-side-content">
              <FrontSideView {...restProps} />
            </div>
          </ScrollBox>
        )}
      </div>
    );
  }
}

const ReportPartFrontSideContainer = props => {
  const reportConfig = ReportPartTypeManager.getReportPartType(props.reportPart.type);
  commonDataStore.loadCustomDataFormat();

  if (includes(reportConfig.value, [TYPE.Chart, TYPE.Gauge, TYPE.Map])) {
    return React.createElement(Dimensions(ReportPartFrontSide), props);
  } else {
    return React.createElement(ReportPartFrontSide, props);
  }
};

ReportPartFrontSideContainer.displayName = 'ReportPartFrontSideContainer';

export default ReportPartFrontSideContainer;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.ReportPartFrontSide.js